/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  if (window.location.pathname == '/') {
    var header = document.querySelector('.header__wrapper');

    header.addEventListener('mouseenter', function() {
      this.classList.add('is-visible');
      this.setAttribute('data-header-transparent', 'false');
    });

    header.addEventListener('mouseleave', function() {
      if (!this.classList.contains('js__header__stuck')) {
        this.classList.remove('is-visible');
        this.setAttribute('data-header-transparent', 'true');
      }
    });

    var observer = new MutationObserver(function(mutations) {

    });

    var config = { attributes: true, childList: true, characterData: true };
    observer.observe(header, config);
  }
})();

const MiniTrios = {
  selectedScents: ['', '', ''],
  miniTriosData: [],
  inventoryLevel: 0,
  atcEnabled: false,

  init() {
    if (document.querySelector('#mini-trios-natural-deodorant-corpus®')) {
      
      this.fetchVariantData();
      this.updateUI(null);
      this.updateCTA(this.toggleATCButton(0, null));

      const formSelectors = document.querySelector('.form__selectors');
      formSelectors.addEventListener('change', this.handleScentSelection.bind(this));
     
      // storing the initial heading data
      document.querySelectorAll('.mini-trio-image-heading').forEach(container => {
        container.dataset.originalHtml = container.innerHTML;
      });
    }
  },
  
  fetchVariantData() {
    this.miniTriosData = window.VuexState.product_lists.minis.map(mini => ({...mini, scents: [mini.title]}));
  },

  async handleScentSelection(e) {
    if (e.target.type === 'radio') {
      const splitName = e.target.name.split('_');
      const rowIndex = parseInt(splitName[2]) - 1;
      this.selectedScents[rowIndex] = e.target.value;
      console.log('Updated selectedScents:', this.selectedScents);
  
      const scentInfo = this.miniTriosData.find(mini => mini.title === e.target.value);
      const headingContainer = document.querySelector(`.mini-trio-image-heading[data-row="${rowIndex + 1}"]`);
      if (scentInfo && headingContainer) {
        headingContainer.innerHTML = `${scentInfo.title} - ${scentInfo.description}`;
      }
    }

    await this.updateUI(this.selectedScents);
    
    if (this.selectedScents.filter(scent => scent !== '').length >= 2) {
      const combinationTitle = this.handleCombinationTitle(this.selectedScents);
      const inventoryLevel = await this.handleInventory(combinationTitle);
      const unavailableCombinations = await this.filterUnavailableCombinations(this.selectedScents);    
      const variantId = await this.findVariantIdByTitle(combinationTitle);
      const atcEnabled = this.toggleATCButton(inventoryLevel, variantId);
      this.markScentsInactive(this.selectedScents, unavailableCombinations);      
      await this.updateCTA(atcEnabled, variantId);

      setTimeout(() => {
        document.querySelectorAll('.out-of-stock-text').forEach(element => {
          element.classList.remove('hidden');
        });
      }, 100);

      console.log('Inventory Level:', inventoryLevel);
      console.log('Variant ID:', variantId);
    }
  },
  

  handleCombinationTitle(selectedScents) {
    const combinationTitle = selectedScents.join(' / ');
    console.log('Combination Title:', combinationTitle);
    return combinationTitle;  
  },  

  async filterUnavailableCombinations(selectedScents) {
    const unavailableCombinations = new Set(); // Using Set to avoid duplicates
    
    this.miniTriosData.forEach(product => {
      product.variants.forEach(variant => {
        const scentsInVariant = variant.option1.split(' / ');
  
        if (variant.inventory_quantity <= 0) {
          let shouldConsider = true;
          for (let i = 0; i < selectedScents.length; i++) {
            if (selectedScents[i] && scentsInVariant[i] !== selectedScents[i]) {
              shouldConsider = false;
              break;
            }
          }
  
          if (shouldConsider) {
            console.log('Zero inventory for:', variant.option1); 
            unavailableCombinations.add(variant.option1);
          }
        }
      });
    });
    
    return Array.from(unavailableCombinations);
  },  

  async findVariantIdByTitle(combinationTitle) {
    try {
      const response = await fetch(`/collections/mini-trios-bundles/products.json`);
      const data = await response.json();
      let foundVariant;
  
      for (const product of data.products) {
        foundVariant = product.variants.find(variant => variant.option1 === combinationTitle);
        if (foundVariant) break;
      }
  
      if (foundVariant) {
        console.log('Found variant:', foundVariant);
        const atcButton = document.querySelector('[data-add-to-cart]');
        atcButton.setAttribute('data-variant-id', foundVariant.id);
        document.querySelector('input[name="id"]').value = foundVariant.id;
        return foundVariant.id;
      } else {
        console.log('Variant not found for ATC');
        return null;
      }      
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  },  

  async handleInventory(combinationTitle) {

    //zero-inventory for testing
    // const zeroInventoryCombinations = [
    //   'California 1.2 / California 1.2 / Cedar Flora 1.2',
    //   'California 1.2 / California 1.2 / Neroli 1.2',
    //   'California 1.2 / Cedar Flora 1.2 / California 1.2',
    //   'California 1.2 / Cedar Flora 1.2 / Cedar Flora 1.2',
    //   'California 1.2 / Cedar Flora 1.2 / Neroli 1.2',
    //   'California 1.2 / Cedar Flora 1.2 / No. Green 1.2',
    //   'California 1.2 / Cedar Flora 1.2 / Santalum 1.2',
    //   'California 1.2 / Cedar Flora 1.2 / Third Rose 1.2',
    //   'California 1.2 / Neroli 1.2 / California 1.2',
    //   'California 1.2 / Neroli 1.2 / Cedar Flora 1.2',
    //   'California 1.2 / Neroli 1.2 / Neroli 1.2',
    //   'California 1.2 / Neroli 1.2 / No. Green 1.2',
    //   'California 1.2 / Neroli 1.2 / Santalum 1.2',
    //   'California 1.2 / Neroli 1.2 / Third Rose 1.2',
    //   'California 1.2 / No. Green 1.2 / Cedar Flora 1.2',
    //   'California 1.2 / No. Green 1.2 / Neroli 1.2',
    //   'California 1.2 / Santalum 1.2 / Cedar Flora 1.2',
    //   'California 1.2 / Santalum 1.2 / Neroli 1.2',
    //   'California 1.2 / Third Rose 1.2 / Cedar Flora 1.2',
    //   'California 1.2 / Third Rose 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / California 1.2 / California 1.2',
    //   'Cedar Flora 1.2 / California 1.2 / Cedar Flora 1.2',
    //   'Cedar Flora 1.2 / California 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / California 1.2 / No. Green 1.2',
    //   'Cedar Flora 1.2 / California 1.2 / Santalum 1.2',
    //   'Cedar Flora 1.2 / California 1.2 / Third Rose 1.2',
    //   'Cedar Flora 1.2 / Cedar Flora 1.2 / California 1.2',
    //   'Cedar Flora 1.2 / Cedar Flora 1.2 / Cedar Flora 1.2',
    //   'Cedar Flora 1.2 / Cedar Flora 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / Cedar Flora 1.2 / No. Green 1.2',
    //   'Cedar Flora 1.2 / Cedar Flora 1.2 / Santalum 1.2',
    //   'Cedar Flora 1.2 / Cedar Flora 1.2 / Third Rose 1.2',
    //   'Cedar Flora 1.2 / Neroli 1.2 / California 1.2',
    //   'Cedar Flora 1.2 / Neroli 1.2 / Cedar Flora 1.2',
    //   'Cedar Flora 1.2 / Neroli 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / Neroli 1.2 / No. Green 1.2',
    //   'Cedar Flora 1.2 / Neroli 1.2 / Santalum 1.2',
    //   'Cedar Flora 1.2 / Neroli 1.2 / Third Rose 1.2',
    //   'Cedar Flora 1.2 / No. Green 1.2 / California 1.2',
    //   'Cedar Flora 1.2 / No. Green 1.2 / Cedar Flora 1.2',
    //   'Cedar Flora 1.2 / No. Green 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / No. Green 1.2 / No. Green 1.2',
    //   'Cedar Flora 1.2 / No. Green 1.2 / Santalum 1.2',
    //   'Cedar Flora 1.2 / No. Green 1.2 / Third Rose 1.2',
    //   'Cedar Flora 1.2 / Santalum 1.2 / California 1.2',
    //   'Cedar Flora 1.2 / Santalum 1.2 / Cedar Flora 1.2',
    //   'Cedar Flora 1.2 / Santalum 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / Santalum 1.2 / No. Green 1.2',
    //   'Cedar Flora 1.2 / Santalum 1.2 / Santalum 1.2',
    //   'Cedar Flora 1.2 / Santalum 1.2 / Third Rose 1.2',
    //   'Cedar Flora 1.2 / Third Rose 1.2 / California 1.2',
    //   'Cedar Flora 1.2 / Third Rose 1.2 / Cedar Flora 1.2',
    //   'Cedar Flora 1.2 / Third Rose 1.2 / Neroli 1.2',
    //   'Cedar Flora 1.2 / Third Rose 1.2 / No. Green 1.2',
    //   'Cedar Flora 1.2 / Third Rose 1.2 / Santalum 1.2',
    //   'Cedar Flora 1.2 / Third Rose 1.2 / Third Rose 1.2',
    //   'Neroli 1.2 / California 1.2 / California 1.2',
    //   'Neroli 1.2 / California 1.2 / Cedar Flora 1.2',
    //   'Neroli 1.2 / California 1.2 / Neroli 1.2',
    //   'Neroli 1.2 / California 1.2 / No. Green 1.2',
    //   'Neroli 1.2 / California 1.2 / Santalum 1.2',
    //   'Neroli 1.2 / California 1.2 / Third Rose 1.2',
    //   'Neroli 1.2 / Cedar Flora 1.2 / California 1.2',
    //   'Neroli 1.2 / Cedar Flora 1.2 / Cedar Flora 1.2',
    //   'Neroli 1.2 / Cedar Flora 1.2 / Neroli 1.2',
    //   'Neroli 1.2 / Cedar Flora 1.2 / No. Green 1.2',
    //   'Neroli 1.2 / Cedar Flora 1.2 / Santalum 1.2',
    //   'Neroli 1.2 / Cedar Flora 1.2 / Third Rose 1.2',
    //   'Neroli 1.2 / Neroli 1.2 / California 1.2',
    //   'Neroli 1.2 / Neroli 1.2 / Cedar Flora 1.2',
    //   'Neroli 1.2 / Neroli 1.2 / Neroli 1.2',
    //   'Neroli 1.2 / Neroli 1.2 / No. Green 1.2',
    //   'Neroli 1.2 / Neroli 1.2 / Santalum 1.2',
    //   'Neroli 1.2 / Neroli 1.2 / Third Rose 1.2',
    //   'Neroli 1.2 / No. Green 1.2 / California 1.2',
    //   'Neroli 1.2 / No. Green 1.2 / Cedar Flora 1.2',
    //   'Neroli 1.2 / No. Green 1.2 / Neroli 1.2',
    //   'Neroli 1.2 / No. Green 1.2 / No. Green 1.2',
    //   'Neroli 1.2 / No. Green 1.2 / Santalum 1.2',
    //   'Neroli 1.2 / No. Green 1.2 / Third Rose 1.2',
    //   'Neroli 1.2 / Santalum 1.2 / California 1.2',
    //   'Neroli 1.2 / Santalum 1.2 / Cedar Flora 1.2',
    //   'Neroli 1.2 / Santalum 1.2 / Neroli 1.2',
    //   'Neroli 1.2 / Santalum 1.2 / No. Green 1.2',
    //   'Neroli 1.2 / Santalum 1.2 / Santalum 1.2',
    //   'Neroli 1.2 / Santalum 1.2 / Third Rose 1.2',
    //   'Neroli 1.2 / Third Rose 1.2 / California 1.2',
    //   'Neroli 1.2 / Third Rose 1.2 / Cedar Flora 1.2',
    //   'Neroli 1.2 / Third Rose 1.2 / Neroli 1.2',
    //   'Neroli 1.2 / Third Rose 1.2 / No. Green 1.2',
    //   'Neroli 1.2 / Third Rose 1.2 / Santalum 1.2',
    //   'Neroli 1.2 / Third Rose 1.2 / Third Rose 1.2',
    //   'No. Green 1.2 / California 1.2 / Cedar Flora 1.2',
    //   'No. Green 1.2 / California 1.2 / Neroli 1.2',
    //   'No. Green 1.2 / Cedar Flora 1.2 / California 1.2',
    //   'No. Green 1.2 / Cedar Flora 1.2 / Cedar Flora 1.2',
    //   'No. Green 1.2 / Cedar Flora 1.2 / Neroli 1.2',
    //   'No. Green 1.2 / Cedar Flora 1.2 / No. Green 1.2',
    //   'No. Green 1.2 / Cedar Flora 1.2 / Santalum 1.2',
    //   'No. Green 1.2 / Cedar Flora 1.2 / Third Rose 1.2',
    //   'No. Green 1.2 / Neroli 1.2 / California 1.2',
    //   'No. Green 1.2 / Neroli 1.2 / Cedar Flora 1.2',
    //   'No. Green 1.2 / Neroli 1.2 / Neroli 1.2',
    //   'No. Green 1.2 / Neroli 1.2 / No. Green 1.2',
    //   'No. Green 1.2 / Neroli 1.2 / Santalum 1.2',
    //   'No. Green 1.2 / Neroli 1.2 / Third Rose 1.2',
    //   'No. Green 1.2 / No. Green 1.2 / Cedar Flora 1.2',
    //   'No. Green 1.2 / No. Green 1.2 / Neroli 1.2',
    //   'No. Green 1.2 / Santalum 1.2 / Cedar Flora 1.2',
    //   'No. Green 1.2 / Santalum 1.2 / Neroli 1.2',
    //   'No. Green 1.2 / Third Rose 1.2 / Cedar Flora 1.2',
    //   'No. Green 1.2 / Third Rose 1.2 / Neroli 1.2',
    //   'Santalum 1.2 / California 1.2 / Cedar Flora 1.2',
    //   'Santalum 1.2 / California 1.2 / Neroli 1.2',
    //   'Santalum 1.2 / Cedar Flora 1.2 / California 1.2',
    //   'Santalum 1.2 / Cedar Flora 1.2 / Cedar Flora 1.2',
    //   'Santalum 1.2 / Cedar Flora 1.2 / Neroli 1.2',
    //   'Santalum 1.2 / Cedar Flora 1.2 / No. Green 1.2',
    //   'Santalum 1.2 / Cedar Flora 1.2 / Santalum 1.2',
    //   'Santalum 1.2 / Cedar Flora 1.2 / Third Rose 1.2',
    //   'Santalum 1.2 / Neroli 1.2 / California 1.2',
    //   'Santalum 1.2 / Neroli 1.2 / Cedar Flora 1.2',
    //   'Santalum 1.2 / Neroli 1.2 / Neroli 1.2',
    //   'Santalum 1.2 / Neroli 1.2 / No. Green 1.2',
    //   'Santalum 1.2 / Neroli 1.2 / Santalum 1.2',
    //   'Santalum 1.2 / Neroli 1.2 / Third Rose 1.2',
    //   'Santalum 1.2 / No. Green 1.2 / Cedar Flora 1.2',
    //   'Santalum 1.2 / No. Green 1.2 / Neroli 1.2',
    //   'Santalum 1.2 / Santalum 1.2 / Cedar Flora 1.2',
    //   'Santalum 1.2 / Santalum 1.2 / Neroli 1.2',
    //   'Santalum 1.2 / Third Rose 1.2 / Cedar Flora 1.2',
    //   'Santalum 1.2 / Third Rose 1.2 / Neroli 1.2',
    //   'Third Rose 1.2 / California 1.2 / Cedar Flora 1.2',
    //   'Third Rose 1.2 / California 1.2 / Neroli 1.2',
    //   'Third Rose 1.2 / Cedar Flora 1.2 / California 1.2',
    //   'Third Rose 1.2 / Cedar Flora 1.2 / Cedar Flora 1.2',
    //   'Third Rose 1.2 / Cedar Flora 1.2 / Neroli 1.2',
    //   'Third Rose 1.2 / Cedar Flora 1.2 / No. Green 1.2',
    //   'Third Rose 1.2 / Cedar Flora 1.2 / Santalum 1.2',
    //   'Third Rose 1.2 / Cedar Flora 1.2 / Third Rose 1.2',
    //   'Third Rose 1.2 / Neroli 1.2 / California 1.2',
    //   'Third Rose 1.2 / Neroli 1.2 / Cedar Flora 1.2',
    //   'Third Rose 1.2 / Neroli 1.2 / Neroli 1.2',
    //   'Third Rose 1.2 / Neroli 1.2 / No. Green 1.2',
    //   'Third Rose 1.2 / Neroli 1.2 / Santalum 1.2',
    //   'Third Rose 1.2 / Neroli 1.2 / Third Rose 1.2',
    //   'Third Rose 1.2 / No. Green 1.2 / Cedar Flora 1.2',
    //   'Third Rose 1.2 / No. Green 1.2 / Neroli 1.2',
    //   'Third Rose 1.2 / Santalum 1.2 / Cedar Flora 1.2',
    //   'Third Rose 1.2 / Santalum 1.2 / Neroli 1.2',
    //   'Third Rose 1.2 / Third Rose 1.2 / Cedar Flora 1.2',
    //   'Third Rose 1.2 / Third Rose 1.2 / Neroli 1.2'                
    // ];
    
    // for (const product of this.miniTriosData) {
    //   for (const variant of product.variants) {
    //     if (zeroInventoryCombinations.includes(variant.option1)) {
    //       variant.inventory_quantity = 0;
    //     }
    //   }
    // }
  
    for (const product of this.miniTriosData) {
      const foundVariant = product.variants.find(variant => variant.option1 === combinationTitle);
      if (foundVariant) {
        this.inventoryLevel = foundVariant.inventory_quantity;
        return this.inventoryLevel;
      }
    }
  
    // If no matching variant is found, set inventory to 0
    this.inventoryLevel = 0;
    return 0;
  },  

  toggleATCButton(inventoryLevel, variantId) {
    console.log('Toggle ATC called with:', inventoryLevel, variantId);
    if (inventoryLevel > 0 && this.selectedScents.every(scent => scent !== '')) {
      return true;
    } else {
      return false;
    }
  },  

  markScentsInactive(selectedScents, unavailableCombinations) {
    // Remove 'inactive' class from all items
    document.querySelectorAll('.block-trios__item.inactive').forEach(item => {
      item.classList.remove('inactive');
    });
  
    // Mark all selected scents as inactive if all 3 are chosen and out of stock
    if (this.selectedScents.every(scent => scent !== '') && this.inventoryLevel <= 0) {
      this.selectedScents.forEach((scent, i) => {
        const radioButton = document.querySelector(`input[name="mini_option_${i + 1}"][value="${scent}"]`);
        if (radioButton) {
          radioButton.closest('.block-trios__item').classList.add('inactive');
        }
      });
      return;
    }
  
    unavailableCombinations.forEach(combination => {
      const scentsInCombination = combination.split(' / ');
  
      for (let i = 0; i < scentsInCombination.length; i++) {
        const scent = scentsInCombination[i];
        
        // Skip marking the scent as inactive if it's currently selected in the same row
        if (selectedScents[i] === scent) continue;
  
        const radioButton = document.querySelector(`input[name="mini_option_${i + 1}"][value="${scent}"]`);
        if (radioButton) {
          radioButton.closest('.block-trios__item').classList.add('inactive');
        }
      }
    });
  },  

  async updateCTA(atcEnabled, variantId) {
    const atcButton = document.querySelector('[data-add-to-cart]');
    if (atcEnabled) {
      atcButton.removeAttribute('disabled');
      atcButton.setAttribute('data-variant-id', variantId); // storing the variantId
    } else {
      atcButton.setAttribute('disabled', 'disabled');
    }
  },  
  
  async updateUI(selectedScents) {      
    for (const [index, scent] of selectedScents.entries()) {
      if (scent !== '') {
        const selectedRadio = document.querySelector(`input[name="mini_option_${index + 1}"][value="${scent}"]`);
        const closestContainer = selectedRadio.closest('.mini-trio-grid-container');
        const imageElement = closestContainer.querySelector('.mini-trio-product-image');
        const headingElement = closestContainer.querySelector('.mini-trio-heading');
  
        const productHandle = selectedRadio.closest('.block-trios__item').getAttribute('data-product-handle');
        const productDisplayTitle = selectedRadio.closest('.block-trios__item').getAttribute('data-display-title');
        const dataImgSrc = selectedRadio.closest('.block-trios__item').getAttribute('data-img-src');
  
        const response = await fetch(`/products/${productHandle}.json`);
        const data = await response.json();
        const product = data.product;
        imageElement.src = dataImgSrc;
        imageElement.alt = product.title;
        headingElement.classList.add('data-populated');
        headingElement.innerHTML = `<h3>${productDisplayTitle}</h3><p>${product.body_html}</p>`;
      }
    }
  }
  
  
};

document.addEventListener('DOMContentLoaded', () => {
  MiniTrios.init();
});


/* Javascript - Show cart drawer when product added to cart */
document.addEventListener('theme:cart:popdown', (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: false,
      })
    );
    document.removeEventListener('theme:cart:change', listener);
  };
  document.addEventListener('theme:cart:change', listener);
});
/* end */